'use client'

import { useSidebarStore } from '../hooks/sidebarStore'
import ShopList from '../components/product-shops/ShopList'

export default function Product() {
  const { isCollapsed } = useSidebarStore()
  return (
    <div className={`min-h-screen mt-4 md:grid-cols-3 lg:grid-cols-5 gap-6 p-6 transition-all duration-300 ${isCollapsed ? 'md:ml-16' : 'md:ml-64'}`}>
      <ShopList />
    </div>
  )
}
